/* LastActivityChart auto-generated by npm run generator */
import { Bar } from "@nivo/bar"
import { clampNumber, Client, UserStatus } from "@qlarity/common"
import ChartCard from "components/atoms/ChartCard"
import { observer } from "mobx-react"
import React from "react"
import Store from "store/Store"
import { defaultTheme } from "style"
import { defaultNivo } from "style/nivoTheme"

interface LastActivityChartProps {
    clients: Client[] | undefined
}

const LastActivityChart: React.FC<LastActivityChartProps> = ({ clients }) => {
    const makePastDate = (pastDays: number): Date => {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() - pastDays)
    }
    const labels = [
        { label: "Today", timestamp: makePastDate(0), "Last Activity": 0 },
        { label: "Last 3 Days", timestamp: makePastDate(3), "Last Activity": 0 },
        { label: "Last 7 Days", timestamp: makePastDate(7), "Last Activity": 0 },
        { label: "Last 14 Days", timestamp: makePastDate(14), "Last Activity": 0 },
        { label: "+14 Days", timestamp: new Date(0), "Last Activity": 0 },
    ]
    const preparedData = React.useMemo(() => {
        const data = labels
        clients
            ?.filter((client) => client.status === UserStatus.ACTIVE)
            .forEach((client) => {
                if (!client.checkins || client.checkins.length === 0) {
                    return
                }

                const lastCheckin = Store.clientStore.findLastActivity(client)
                if (lastCheckin) {
                    const bucket = labels.findIndex((label) => lastCheckin > label.timestamp)
                    data[bucket]["Last Activity"] += 1
                }
            })
        return data
    }, [clients, labels])
    const maxY = preparedData.reduce((max, curr) => (max >= curr["Last Activity"] ? max : curr["Last Activity"]), 1)
    const numTicks = clampNumber(maxY, 1, 5)

    return (
        <ChartCard title="Last Activity" subtitle="Frequency">
            <Bar
                theme={defaultNivo}
                colors={defaultTheme.palette.info.main}
                width={700}
                height={300}
                data={preparedData}
                indexBy={"label"}
                keys={["Last Activity"]}
                margin={{ bottom: 24, top: 32, left: 40, right: 40 }}
                enableGridX
                axisLeft={{ tickValues: numTicks, legend: "Active Users", legendOffset: -30, legendPosition: "middle" }}
                // PR for adding this to types: https://github.com/plouc/nivo/pull/855
                // @ts-ignore
                gridYValues={numTicks}
            />
        </ChartCard>
    )
}

export default observer(LastActivityChart)
